import * as React from 'react';
const SvgCheck = (props) => (
   <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={56} height={56} {...props}>
      <defs>
         <path
            id="check_svg__a"
            d="M37.878 16.946a2.96 2.96 0 0 1 4.172-.166 2.933 2.933 0 0 1 .167 4.156L24.503 40.054a2.96 2.96 0 0 1-4.257.085l-7.381-7.353a2.933 2.933 0 0 1 0-4.16 2.96 2.96 0 0 1 4.175 0l5.208 5.189z"
         />
      </defs>
      <use xlinkHref="#check_svg__a" fill={props.fill ? props.fill : '#4A4A4A'} fillRule="nonzero" />
   </svg>
);
export default SvgCheck;
